import React, { useEffect, useMemo, useState } from 'react'
import { RecursiveComponent } from './RecursiveComponent'
import { PollComponentProps } from './PollComponentType'
import styles from '../Poll.module.scss'
import LxCancelButton from '@src/components/cancelButton/LxCancelButton'
import { cn } from '@src/utils/cn'
import LxSaveButton from '@src/components/saveButton/LxSaveButton'
import { normalizeOptional } from '../Poll'

export const PollPage: React.FC<PollComponentProps> = ({ style, data, responseCallback }) => {
  const [submitted, setSubmitted] = useState(false)
  const [componentResponse, setComponentResponse] = useState<Record<string, any>>({})
  const [isOptional, setIsOptional] = useState(false)

  const onResponse = (id: string, value: any) => {
    setComponentResponse((prev) => ({ ...prev, [id]: value }))
  }

   const enhancedData = useMemo(() => {
    if (!data?.properties?.components) return data?.properties?.components

    const enhanceComponent = (component: any): any => {
      const enhanced = {
        ...component,
        props: {
          ...component.props,
          value: componentResponse[component.id] !== undefined 
            ? componentResponse[component.id] 
            : component.props?.value
        }
      }

      if (component.children) {
        enhanced.children = component.children.map(enhanceComponent)
      }

      return enhanced
    }

    return data.properties.components.map(enhanceComponent)
  }, [data?.properties?.components, componentResponse])

  const onSubmit = (skipped: boolean) => {
    setSubmitted(true)
    responseCallback({
      skipped,
      answer: skipped ? {} : componentResponse,
    })
  }

  useEffect(() => {
    setSubmitted(false)
    setIsOptional(normalizeOptional(data?.optional))
  }, [data])

  return (
    <div className={styles.pollContainer} style={style}>
      <div className={styles.pollMain}>
        <RecursiveComponent data={enhancedData} responseCallback={onResponse} />
      </div>
      <div className={styles.pollFooter}>
        {isOptional && (
          <LxCancelButton
            onCancel={() => onSubmit(true)}
            disabled={submitted}
            label={data?.properties?.btn_skip || 'Skip'}
            classNames={cn('lxActionButton', 'lxActionButtonDefaultSize', styles.pollButton)}
          />
        )}

        <LxSaveButton
          disabled={submitted}
          onSubmit={() => onSubmit(false)}
          label={data?.properties?.btn_ok || 'Ok'}
          classNames={cn('lxActionButton', 'lxActionButtonDefaultSize', 'lxActionButtonFilled', styles.pollButton)}
        />
      </div>
    </div>
  )
}
